module.exports = __webpack_public_path__ + "static/media/begegnung_treff.104baf71.jpg";